export default "__VITE_PUBLIC_ASSET__2f975410__"